<template>
  <div id="device-bg-main">
    <timer />
    <check-out-cost-shift-page />
  </div>
</template>

<script>
import CheckOutCostShiftPage from '../components/CheckOutCostShiftPage';
import timer from '../components/Timer.vue';
      export default {
        name: 'CheckOutCostShift',
        components: {
          CheckOutCostShiftPage,
          timer,
        },
      };
</script>
